export const buildConnectivityInfo = (segments, fromTime, toTime) => {
  const datas = [];
  const sorted = [...(segments || [])]
    .filter(s => s && typeof s.startedAt === "number" && typeof s.endedAt === "number" && s.startedAt < toTime && s.endedAt > fromTime)
    .sort((a, b) => a.startedAt - b.startedAt);

  let prevEnd = fromTime;
  let isFirstSegment = true;

  if (sorted.length === 0) {
    return [];
  }

  sorted.forEach((seg) => {
    const start = Math.max(seg.startedAt, fromTime);
    const end = Math.min(seg.endedAt, toTime);

    if (start > prevEnd) {
      if (isFirstSegment) {
        // Default connectivity status before the first "startedAt" (grey)
        datas.push({
          name: "Empty",
          value: [prevEnd, start],
        });
      } else {
        // Default connectivity status after the first "startedAt" (green)
        datas.push({
          name: "Online",
          value: [prevEnd, start],
        });
      }
    }

    isFirstSegment = false;

    const status = String(seg.status ?? "").trim().toLowerCase();
    datas.push({
      name: status === "offline" ? "Offline" : "Online",
      value: [start, end],
    });

    prevEnd = Math.max(prevEnd, end);
  });

  if (prevEnd < toTime) {
    datas.push({
      name: "Online",
      value: [prevEnd, toTime],
    });
  }

  return datas;
};

export const calculateTotalOfflineDuration = (segments = [], fromTime, toTime) => {
  return (segments || [])
    .filter(s => s && typeof s.startedAt === "number" && typeof s.endedAt === "number" && s.startedAt < toTime && s.endedAt > fromTime)
    .reduce((acc, seg) => {
      const start = Math.max(seg.startedAt, fromTime);
      const end = Math.min(seg.endedAt, toTime);
      return acc + (end - start);
    }, 0);
};

export const fetchClientsData = async ({
  summaryReportId,
  standalone,
  auth,
  requestUuid,
  sendBatch,
}) => {
  if (!summaryReportId) return [];

  const apiKey = standalone
    ? "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/clients.read"
    : "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/clients.read";

  const restfulPlaceholders = standalone
    ? { orgId: auth.realm?.id, siteId: auth.sites?.id, summaryReportId }
    : { entId: auth.realm?.id, orgId: auth.orgs?.id, siteId: auth.sites?.id, summaryReportId };

  const { getSendBatchData } = await sendBatch([
    { apiKey, requestUuid, restfulPlaceholders, params: {} }
  ]);
  const res = getSendBatchData({ requestUuid }) || {};
  return Array.isArray(res?.data?.items) ? res?.data?.items : [];
};
